import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => this.focusErrorSummaryOrFallback())
  }

  focusErrorSummaryOrFallback() {
    const explanation = document.getElementById("error_explanation")

    if (explanation?.classList.contains("alert-form")) {
      this.focusFirstInvalidField()
      return
    }

    const heading = document.getElementById("error_explanation_heading")
    if (heading) {
      if (!heading.hasAttribute("tabindex")) {
        heading.setAttribute("tabindex", "-1")
      }
      heading.focus()
      return
    }

    if (explanation) {
      if (!explanation.hasAttribute("tabindex")) {
        explanation.setAttribute("tabindex", "-1")
      }
      explanation.focus()
      return
    }

    this.focusFirstInvalidField()
  }

  focusFirstInvalidField() {
    const first = this.element.querySelector(".error-control, [aria-invalid='true']")
    if (first) {
      first.focus()
    }
  }
}
